import React from 'react';
import { format } from 'date-fns';
import { JdsButton } from '../../../components/jds/JdsButton';
import { EyeIcon } from '../../../components/jds/icons';

export const columns = [
  {
    name: 'Data/Hora',
    selector: (row) =>
      row.createdAt ? format(new Date(row.createdAt), 'dd/MM/yyyy HH:mm') : '-',
  },
  {
    name: 'Tipo consulta',
    selector: (row) => row.queryType || '-',
  },
  {
    name: 'Documento',
    selector: (row) => row.document || '-',
  },
  {
    name: 'Retorno XML',
    cell: (row) => (
      <JdsButton
        variant="ghost"
        color="neutral"
        size="sm"
        iconOnly
        aria-label="Ver retorno XML"
        onClick={() => alert(JSON.stringify(row.queryResponse))}
      >
        <EyeIcon />
      </JdsButton>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
  },
  {
    name: 'Retorno JSON',
    cell: (row) => (
      <JdsButton
        variant="ghost"
        color="neutral"
        size="sm"
        iconOnly
        aria-label="Ver retorno JSON"
        onClick={() => alert(JSON.stringify(row.queryResponsePlain))}
      >
        <EyeIcon />
      </JdsButton>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
  },
  {
    name: 'Link PDF',
    cell: (row) =>
      row.pdf ? (
        <a href={row.pdf} target="_blank" rel="noopener noreferrer">
          Visualizar
        </a>
      ) : (
        '-'
      ),
  },
];
